import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { FaFolder } from "react-icons/fa";
import { Navbar } from "../components";

import { styles } from "../styles";

const ErrorPage = ({
  code = "404",
  titleKey = "error.404_title",
  defaultTitle = "Halaman Tidak Ditemukan",
  subtitleKey = "error.404_subtitle",
  defaultSubtitle = "Kami tidak dapat menemukan halaman yang anda cari. Anda dapat kembali ke",
  hideNavbar = false,
}) => {
  return (
    <section>
      {!hideNavbar && <Navbar />}
      <div className="flex flex-col items-center justify-center max-w-full h-full pt-[160px] lg:px-36 md:px-16 sm:px-6">
        <div className="relative flex items-center justify-center">
          {/* Dynamic Error Code */}
          <h1 className={`${styles.headingL} absolute text-white mt-4`}>
            {code}
          </h1>
          <FaFolder className="fill-neutral-90 h-[180px] w-[180px]" />
        </div>
        <div className="flex flex-col items-center justify-center">
          {/* Dynamic Title */}
          <h1 className={`${styles.headingL} text-center text-danger-40`}>
            <Trans i18nKey={titleKey}>{defaultTitle}</Trans>
          </h1>
          <p
            className={`lg:${styles.textLRegular} sm:text-[12px] sm-leading-4 text-neutral-90 md:text-center mt-2`}
          >
            {/* Dynamic Subtitle */}
            <Trans i18nKey={subtitleKey}>{defaultSubtitle}</Trans>{" "}
            <Link to="/" className="text-danger-40 hover:underline">
              {/* Added fallback text for the link to match your locales */}
              <Trans i18nKey="error.link">halaman utama.</Trans>
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ErrorPage;
